module.exports = __webpack_public_path__ + "static/peg-insert-18fcdbdc216d618c4161935d7b24b496.gif";